module.exports = __webpack_public_path__ + "assets/img/weekly-report.41d0f7ff.png";